import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface BreadCrumb {
  name: string,
  id: string,
  url: string
}

@Component({
  standalone: true,
  selector: 'app-breadcrumb-navigation',
  templateUrl: './breadcrumb-navigation.component.html',
  styleUrls: ['./breadcrumb-navigation.component.scss'],
  imports: [CommonModule, RouterModule]
})
export class BreadcrumbNavigationComponent {


  readonly breadcrumbData = input<BreadCrumb[]>([]);
  readonly selectedCategoryId = input<string>('');
}

